import {
  ContactProfileManagementView,
  ContactsManagementView,
  ContactsMergeView,
  ContactsView,
} from '../../Views/Home';

export const ContactsRoutesPropertyManagement = [
  {
    path: '/view',
    name: 'ContactsView:contacts',
    component: ContactsView,
    layout: '/home/contact-property-management',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
    ],
  },
  {
    path: '/add',
    name: 'homeLayout.contactsManagementView.contacts-management-view',
    component: ContactsManagementView,
    layout: '/home/contact-property-management',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
      {
        name: 'homeLayout.contactsManagementView.contacts-management-view',
        isDisabled: true,
        route: '/home/contact-property-management/add',
      },
    ],
  },
  {
    path: '/contact-profile-edit',
    name: 'ContactProfileManagementView:contact-profile-edit',
    component: ContactProfileManagementView,
    layout: '/home/contact-property-management',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-edit',
        isDisabled: true,
        route: '/home/contact-property-management/contact-profile-edit',
      },
    ],
  },
  {
    path: '/contact-profile-add',
    name: 'ContactProfileManagementView:contact-profile-add',
    component: ContactProfileManagementView,
    layout: '/home/contact-property-management',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
      {
        name: 'ContactProfileManagementView:contact-profile-add',
        isDisabled: true,
        route: '/home/contact-property-management/contact-profile-add',
      },
    ],
  },
  {
    path: '/edit',
    name: 'homeLayout.contactsManagementView.contacts-management-view',
    component: ContactsManagementView,
    layout: '/home/contact-property-management',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
      {
        name: 'homeLayout.contactsManagementView.contacts-management-view',
        isDisabled: true,
        route: '/home/contact-property-management/edit',
      },
    ],
  },
  {
    path: '/merge',
    name: 'ContactsView:contacts',
    component: ContactsMergeView,
    layout: '/home/contact-property-management',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'ContactsView:contacts',
        isDisabled: false,
        route: '/home/contact-property-management/view',
        groupName: 'property-management',
      },
      {
        name: 'homeLayout.contactsManagementView.merge-contacts',
        isDisabled: true,
        route: '/home/contact-property-management/merge',
      },
    ],
  },
];
